import { render, staticRenderFns, recyclableRender, components } from "./labelsPicker.vue?vue&type=template&id=52aff8b4&scoped=true&"
var renderjs
import script from "./labelsPicker.vue?vue&type=script&lang=js&"
export * from "./labelsPicker.vue?vue&type=script&lang=js&"
import style0 from "./labelsPicker.vue?vue&type=style&index=0&id=52aff8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aff8b4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/common/labelsPicker.vue"
export default component.exports